<app-spinner-service></app-spinner-service>
<form [formGroup]="editarContaContabil" (ngSubmit)="onSubmit()" class="w-auto pt-4 pl-6 pr-6 pb-6">

    <div class="grid p-fluid col-12">

        <div class="flex-auto col-6 mb-3">
            <label for="codigo">Código</label>
            <input id="codigo" readonly pInputText formControlName="codigo" variant="filled" class="w-full mt-1" />
        </div>

        <div class="flex-auto col-6 mb-3">
            <label for="contaSuperior">Conta Superior</label>
            <input id="contaSuperior" readonly pInputText formControlName="contaSuperior" variant="filled"
                class="w-full mt-1" />
        </div>

        <div class="flex-auto col-6 mb-3">
            <label for="nivel">Nível</label>
            <input id="nivel" readonly pInputText formControlName="nivel" variant="filled" class="w-full mt-1" />
        </div>

        <div class="flex-auto col-6 mb-3">
            <label for="tipo">Tipo</label>
            <input id="tipo" readonly pInputText [value]="retornaTipo(editarContaContabil.get('tipo').getRawValue())"
                variant="filled" class="w-full mt-1" />
        </div>

        <div class="flex-auto col-6 mb-3">
            <label for="descricao">Descrição</label>
            <input id="descricao" pInputText formControlName="descricao" class="w-full mt-1" />
        </div>

        <div class="flex-auto col-6 mb-3">
            <label for="saldo">Saldo</label>
            <p-inputNumber class="w-full mt-1" inputId="saldo" formControlName="saldo" mode="currency" currency="BRL"
                locale="pt-BR" />
        </div>

        <div class="col-12 flex justify-content-between">
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger"
                    (click)="onCancel()"></p-button>
            </div>
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="submit" label="Salvar" icon="pi pi-check"
                    [disabled]="editarContaContabil.invalid"></p-button>
            </div>
        </div>
    </div>
</form>